import { Component, Emit, Model, Prop, Vue } from 'vue-property-decorator';
import TaskList from '@/components/TaskList/TaskList.vue';
import { Report } from '@/models/Report';
import { Task } from '@/models/Task';
import { AxiosError, AxiosResponse } from 'axios';
import ErrorHandler from '@/support/ErrorHandler';

@Component<Tasks>({
  components: {
    TaskList,
  },
})
export default class Tasks extends Vue {
  protected $pageTitle = 'Taken';

  @Model('report', { default: () => new Report() })
  protected report!: Report;

  protected tasks: Task[] = [];

  @Model('readOnly', { default: false })
  protected readOnly = false;

  @Prop({ default: false })
  protected syncing!: boolean;

  protected isLoading = true;

  protected tasksCompleted = false;

  protected priceTotal = 0;

  @Emit()
  protected changeStatus(status: string): string {
    return status;
  }

  protected async mounted(): Promise<void> {
    await this.fetchTasks();
  }

  protected handleTaskUpdated(): void {
    this.fetchTasks();
  }

  protected async fetchTasks(): Promise<void> {
    if (! this.$route.params.id) {
      return;
    }

    if (! this.report) {
      return;
    }

    if (! this.report.uuid) {
      return;
    }

    await new Task()
      .include(['sub_tasks', 'media', 'prices'])
      .include_meta(['prices'])
      .listTasks(this.report.uuid, false)
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      .then((response: any) => {
        this.tasksCompleted = ! (response.data as Task[]).some((task: Task): boolean => task.status_raw !== 'done');
        this.tasks = (response.data as Task[]);
        this.priceTotal = response.meta?.prices?.sum_incl;
      })
      .catch((error: AxiosError) => {
        ErrorHandler.network(error);
      });
  }
}
